import Project from "./Project";
import classes from "./Projects.module.scss";

const Projects = () => {
  return (
    <div className={classes["projects"]}>
      <div className={classes["projects__label"]}>
        <h1>Projects</h1>
      </div>
      <Project
        imagePath="assets/eco-fresh.png"
        imageAlt="Eco Fresh website"
        projectName="Eco Fresh"
        projectUrl="https://hubert123490.github.io/eco-fresh-frontend-angular/landing-page"
      >
        A full-stack web application for food delivery. Learning project to improve native CSS, Angular,
        Quarkus and Stripe integration skills.
      </Project>
      <Project
        even={true}
        imagePath="assets/learning-system.png"
        imageAlt="E-learning platform"
        projectName="E-learning platform"
        projectUrl="https://learning-system-react.herokuapp.com/"
      >
        A full-stack web application for remote education, built with React,
        Spring Boot, and MySQL, with integrated Cisco Webex for live sessions.
        The platform supports both Polish and English languages and provides
        role-based access for teachers and students. It enables the creation and
        management of lessons, exams, and assignments, supports student progress
        tracking, and includes JWT-based authentication and authorization.
      </Project>
      <Project
        imagePath="assets/pms.png"
        imageAlt="Property managment system"
        projectName="Property managment system"
        projectUrl="https://pms-vue.herokuapp.com/en/"
      >
        A web application for managing and renting properties, built with Vue,
        Spring Boot, and MySQL. It features Stripe integration for payments and
        OAuth authentication via Google ({" "}
        <span style={{ color: "red" }}>
          currently disabled for data security reasons
        </span>
        ). Developed in collaboration with an academic colleague, the platform
        supports two user roles: landlord and client. Landlords can list
        properties with customizable features such as nightly price and number
        of beds, while clients can browse, book stays for specific dates, and
        complete payments securely through Stripe. The application supports both
        Polish and English languages.
      </Project>

      <Project
        even={true}
        imagePath="assets/GitHub_Logo.png"
        imageAlt="Github projects"
        projectName="GitHub"
        projectUrl="https://github.com/hubert123490"
      >
        I've also developed smaller desktop and mobile applications. You can
        check them out by visiting my GitHub page.
      </Project>
    </div>
  );
};

export default Projects;
